/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { Section } from '~core/models/core.models';
import { ApiConstantsService } from './api-constants.service';
import { FreeRequestParams } from '~core/models/shared.models';

@Injectable()
export class PageService {
  protected _httpClient = inject(HttpClient);
  protected _apiConstantsService = inject(ApiConstantsService);

  readHomePage(params?: FreeRequestParams): Observable<Section[]> {
    return this._httpClient
      .get<{
        sections: Section[];
      }>(`${this._apiConstantsService.pageUrl}/homepage`, {
        params: {
          ...params,
          details: '',
          sort: params?.sort || 'createdAt',
          desc: params?.desc || 'createdAt'
        } as Record<string, any>
      })
      .pipe(map(res => res.sections));
  }

  readProgramPage(
    programId: string,
    params?: FreeRequestParams
  ): Observable<Section[]> {
    const headers: { [key: string]: string } = {};
    if (params && params['channelId']) {
      headers['X-Channel-Id'] = params['channelId'];
      delete params['channelId'];
    }
    return this._httpClient
      .get<{
        sections: Section[];
      }>(
        `${this._apiConstantsService.pageUrl}/programs${programId ? '/' + programId : ''}`,
        {
          headers,
          params: {
            ...params,
            details: '',
            sort: params?.sort || 'createdAt',
            desc: params?.desc || 'createdAt'
          } as Record<string, any>
        }
      )
      .pipe(map(res => res.sections));
  }

  channelPage(
    channelId: string,
    params?: FreeRequestParams
  ): Observable<Section[]> {
    return this._httpClient
      .get<{
        sections: Section[];
      }>(`${this._apiConstantsService.pageUrl}/channels/${channelId}`, {
        params: {
          ...params,
          details: '',
          sort: params?.sort || 'createdAt',
          desc: params?.desc || 'createdAt'
        } as Record<string, any>,
        headers: {
          'X-Channel-Id': channelId
        }
      })
      .pipe(map(res => res.sections));
  }
}
